export const updatesData = [
  {
    id: 1,
    date: '2026-07-31',
    tag: '热播',
    title: '《极限挑战》第十季今晚开播，黄渤孙红雷再度联手',
    summary: '王牌综艺《极限挑战》第十季将于今晚20:00首播，原班人马悉数回归，开启全新城市冒险之旅。',
  },
  {
    id: 2,
    date: '2026-07-30',
    tag: '上新',
    title: '《密室大逃脱》第六季定档预告释出，沉浸式体验升级',
    summary: '全新一季密室大逃脱宣布定档8月8日，六大主题密室首次曝光，VR全景模式同步上线。',
  },
  {
    id: 3,
    date: '2026-07-29',
    tag: '热门',
    title: '《创造营2026》海选报名突破50万，创历史新高',
    summary: '新一季《创造营》全球海选报名人数已突破50万大关，海外赛区报名量同比增长230%。',
  },
  {
    id: 4,
    date: '2026-07-28',
    tag: '专题',
    title: '暑期综艺档排播表完整发布，12档王牌节目轮番登场',
    summary: '2026暑期综艺完整排播出炉，涵盖户外竞技、音乐选秀、推理探案等多类型节目。',
  },
  {
    id: 5,
    date: '2026-07-27',
    tag: '回顾',
    title: '《向往的生活》第九季收官，单期播放量破2亿',
    summary: '本季《向往的生活》圆满收官，全网累计播放量突破40亿，刷新国产慢综艺纪录。',
  },
  {
    id: 6,
    date: '2026-07-26',
    tag: '上新',
    title: '《这就是街舞》第八季导师阵容公布，国际顶尖舞者加盟',
    summary: '第八季导师阵容首次加入两位国际街舞冠军，赛制全面升级为全球街舞联赛模式。',
  },
  {
    id: 7,
    date: '2026-07-25',
    tag: '活动',
    title: '快看影视周年庆：VIP限时特惠，年费低至5折',
    summary: '庆祝平台上线三周年，VIP会员年费限时5折，新用户注册即送7天免费体验。',
  },
  {
    id: 8,
    date: '2026-07-24',
    tag: '专题',
    title: '《脱口秀大会》第七季开放麦全国巡演启动',
    summary: '《脱口秀大会》第七季线下开放麦巡演覆盖20座城市，线上同步直播解锁独家花絮。',
  },
  {
    id: 9,
    date: '2026-07-23',
    tag: '热门',
    title: '《中餐厅》第十季选址曝光，首次走出亚洲落地巴塞罗那',
    summary: '《中餐厅》第十季确认将在巴塞罗那录制，首次将中华美食文化带到欧洲大陆。',
  },
];

export const indexData = [
  {
    id: 1,
    icon: 'ri-fire-line',
    title: '热播排行',
    description: '实时热度榜单，热门综艺一网打尽',
    color: 'primary',
  },
  {
    id: 2,
    icon: 'ri-tv-2-line',
    title: '户外竞技',
    description: '《极限挑战》《奔跑吧》系列合集',
    color: 'accent',
  },
  {
    id: 3,
    icon: 'ri-music-2-line',
    title: '音乐选秀',
    description: '《创造营》《歌手》《中国好声音》全集',
    color: 'secondary',
  },
  {
    id: 4,
    icon: 'ri-lightbulb-flash-line',
    title: '推理探案',
    description: '《密室大逃脱》《明星大侦探》专区',
    color: 'primary',
  },
  {
    id: 5,
    icon: 'ri-restaurant-line',
    title: '美食慢综',
    description: '《中餐厅》《向往的生活》全季收录',
    color: 'accent',
  },
  {
    id: 6,
    icon: 'ri-emotion-laugh-line',
    title: '脱口喜剧',
    description: '《脱口秀大会》《吐槽大会》欢乐不停',
    color: 'secondary',
  },
  {
    id: 7,
    icon: 'ri-rocket-line',
    title: '最新上线',
    description: '每日更新排播，新综艺抢先看',
    color: 'primary',
  },
  {
    id: 8,
    icon: 'ri-star-line',
    title: '经典回顾',
    description: '那些年追过的神综，随时重温',
    color: 'accent',
  },
];

export const appEntryData = {
  title: '快看影视APP',
  subtitle: '随时随地，综艺随身看',
  description: '下载快看影视APP，享受离线缓存、高清投屏、独家花絮等专属权益。支持iOS、Android、iPad及智能电视多端同步。',
  features: ['离线缓存', '高清投屏', '多端同步', '独家花絮', '无广告播放'],
  qrCode: 'https://readdy.ai/api/search-image?query=A%20clean%20minimal%20QR%20code%20style%20app%20download%20graphic%20on%20white%20background%2C%20modern%20flat%20design%2C%20vector%20style%20illustration&width=400&height=400&seq=app-qr-001&orientation=squarish',
  previewImage: 'https://readdy.ai/api/search-image?query=A%20modern%20smartphone%20showing%20a%20Chinese%20variety%20show%20streaming%20app%20interface%20with%20colorful%20show%20thumbnails%20on%20a%20dark%20mode%20screen%2C%20clean%20UI%20design%2C%20minimal%20background%2C%20product%20mockup%20style&width=600&height=900&seq=app-preview-001&orientation=portrait',
};

export const featuresData = [
  {
    id: 1,
    icon: 'ri-speed-mini-line',
    title: '秒播不缓冲',
    description: '采用全球CDN加速与智能预加载技术，点击即播无需等待，弱网环境下也能流畅观看综艺节目。',
  },
  {
    id: 2,
    icon: 'ri-4k-line',
    title: '全高清画质',
    description: '支持1080P蓝光与4K超清分辨率，自适应码率技术根据网络状况智能切换，始终呈现最佳画质。',
  },
  {
    id: 3,
    icon: 'ri-slideshow-line',
    title: '海量片源覆盖',
    description: '收录超过3000档综艺节目的正版片源，从经典老综到最新热播，一站式满足全家人观看需求。',
  },
  {
    id: 4,
    icon: 'ri-shield-check-line',
    title: '纯净观看体验',
    description: '全网首创智能去广告播放模式，无弹窗无干扰，绿色安全的内容环境，专注每一分钟的精彩。',
  },
];

export const rankingData = [
  {
    rank: 1,
    title: '极限挑战 第十季',
    category: '户外竞技',
    heat: '982万',
    trend: 'up',
    change: '+12%',
    tag: '热播中',
  },
  {
    rank: 2,
    title: '密室大逃脱 第六季',
    category: '推理探案',
    heat: '876万',
    trend: 'up',
    change: '+28%',
    tag: '即将上线',
  },
  {
    rank: 3,
    title: '创造营2026',
    category: '音乐选秀',
    heat: '843万',
    trend: 'up',
    change: '+35%',
    tag: '热播中',
  },
  {
    rank: 4,
    title: '向往的生活 第九季',
    category: '美食慢综',
    heat: '791万',
    trend: 'down',
    change: '-5%',
    tag: '已完结',
  },
  {
    rank: 5,
    title: '这就是街舞 第八季',
    category: '舞蹈竞技',
    heat: '754万',
    trend: 'up',
    change: '+18%',
    tag: '即将上线',
  },
  {
    rank: 6,
    title: '脱口秀大会 第七季',
    category: '脱口喜剧',
    heat: '688万',
    trend: 'up',
    change: '+22%',
    tag: '筹备中',
  },
];

export const carouselData = [
  {
    id: 1,
    title: '极限挑战十周年',
    subtitle: '十年热血 初心不改',
    description: '从第一季到第十季，《极限挑战》陪伴观众走过十年。回顾经典名场面，重温那些笑与泪的瞬间，十周年特别企划限时上线。',
    tag: '十周年特辑',
    image: 'https://readdy.ai/api/search-image?query=A%20group%20of%20Chinese%20tv%20show%20hosts%20in%20casual%20outfits%20posing%20together%20outdoors%20in%20an%20urban%20setting%2C%20energetic%20atmosphere%2C%20warm%20lighting%2C%20entertainment%20variety%20show%20promotional%20style%2C%20clean%20composition&width=700&height=440&seq=carousel-01&orientation=landscape',
  },
  {
    id: 2,
    title: '密室大逃脱：全新沉浸季',
    subtitle: '六大主题密室 心跳来袭',
    description: '本季打造六大沉浸式密室场景，从古墓探险到未来都市，VR全景模式让观众身临其境，与嘉宾同步解谜。',
    tag: 'VR全景',
    image: 'https://readdy.ai/api/search-image?query=Mysterious%20dimly%20lit%20escape%20room%20interior%20with%20ancient%20Chinese%20temple%20theme%2C%20atmospheric%20lighting%2C%20puzzle%20elements%2C%20cinematic%20wide%20shot%2C%20moody%20and%20suspenseful%20tone&width=700&height=440&seq=carousel-02&orientation=landscape',
  },
  {
    id: 3,
    title: '创造营2026：全球偶像季',
    subtitle: '50万海选 巅峰对决',
    description: '全新国际赛制升级，来自全球30个国家的练习生汇聚一堂。顶级导师阵容与全新舞台设计，见证下一个全球偶像诞生。',
    tag: '全球海选',
    image: 'https://readdy.ai/api/search-image?query=Grand%20stage%20with%20dramatic%20concert%20lighting%20and%20laser%20effects%2C%20empty%20arena%20ready%20for%20a%20music%20competition%20show%2C%20spectacular%20production%20design%2C%20epic%20atmosphere&width=700&height=440&seq=carousel-03&orientation=landscape',
  },
  {
    id: 4,
    title: '这就是街舞：全球联赛',
    subtitle: '国际顶尖舞者正面交锋',
    description: '第八季全面升级为全球街舞联赛模式，邀请美国、韩国、法国等顶级舞团加盟。全新战队制淘汰赛，燃爆整个夏天。',
    tag: '全球联赛',
    image: 'https://readdy.ai/api/search-image?query=Dynamic%20street%20dance%20performance%20on%20a%20lit%20stage%2C%20dancer%20in%20mid%20motion%2C%20dramatic%20spotlight%2C%20urban%20street%20culture%20aesthetic%2C%20powerful%20and%20energetic%20composition&width=700&height=440&seq=carousel-04&orientation=landscape',
  },
  {
    id: 5,
    title: '中餐厅：巴塞罗那之旅',
    subtitle: '中华美食 飘香欧洲',
    description: '《中餐厅》首次走出亚洲，在巴塞罗那开设期间限定餐厅。用美食连接中西文化，记录海外经营的真实故事与温暖瞬间。',
    tag: '海外特辑',
    image: 'https://readdy.ai/api/search-image?query=A%20bright%20and%20airy%20Chinese%20restaurant%20interior%20with%20warm%20wooden%20furniture%2C%20beautiful%20food%20presentation%2C%20Mediterranean%20view%20through%20windows%2C%20sunny%20Barcelona%20atmosphere%2C%20inviting%20and%20elegant&width=700&height=440&seq=carousel-05&orientation=landscape',
  },
  {
    id: 6,
    title: '暑期综艺嘉年华',
    subtitle: '12档王牌节目 畅爽一夏',
    description: '快看影视暑期档全面启动，12档王牌综艺轮番上阵。户外竞技、音乐选秀、慢综美食、推理探案，总有一档适合你的夏天。',
    tag: '暑期特辑',
    image: 'https://readdy.ai/api/search-image?query=Summer%20outdoor%20festival%20scene%20with%20colorful%20decorations%2C%20warm%20sunset%20lighting%2C%20people%20enjoying%20entertainment%20activities%2C%20lively%20and%20vibrant%20atmosphere%2C%20cinematic%20wide%20composition&width=700&height=440&seq=carousel-06&orientation=landscape',
  },
];

export const contactData = {
  title: '联系我们',
  subtitle: '商务合作 / 内容投稿 / 意见反馈',
  description: '无论您是内容创作者、品牌合作方还是热心观众，我们都期待听到您的声音。快看影视持续开放内容合作与商务洽谈通道，共同打造更优质的综艺观看平台。',
  email: 'contact@kuaikanys.com',
  wechat: 'kuaikanys_official',
  weibo: '@快看影视',
};

export const aboutData = {
  title: '关于快看影视',
  subtitle: '让每一帧精彩 从不等待',
  description: '快看影视成立于2023年，是国内领先的综艺节目在线观看平台。我们致力于为全国观众提供最新、最全、最高清的综艺节目内容，以秒播不缓冲的流畅体验和纯净无干扰的观看环境，重新定义综艺观看方式。\n\n平台收录超过3000档综艺节目，涵盖户外竞技、音乐选秀、推理探案、美食慢综、脱口喜剧等全品类，每日更新最新内容。无论是最新热播综艺还是经典老综，都能在快看影视一站畅享。\n\n我们的技术团队采用全球CDN加速与智能预加载技术，确保在任何网络环境下都能实现点击即播，真正兑现"不缓冲、流畅播放"的承诺。',
  stats: [
    { value: '3000+', label: '收录综艺' },
    { value: '1.2亿', label: '月活用户' },
    { value: '98.6%', label: '播放成功率' },
    { value: '50万+', label: '日均新增内容' },
  ],
};

export const cardsData = [
  {
    id: 1,
    image: 'https://readdy.ai/api/search-image?query=Outdoor%20adventure%20game%20show%20scene%20with%20participants%20completing%20obstacle%20courses%2C%20sunny%20day%2C%20vibrant%20colors%2C%20action%20packed%20moment%2C%20television%20production%20quality&width=600&height=400&seq=cards-01&orientation=landscape',
    tag: '户外竞技',
    title: '极限挑战 第十季重磅回归',
    description: '黄渤、孙红雷领衔原班人马，全新城市冒险篇章，每一期都是意想不到的惊喜与笑料。首期节目今晚20:00首播。',
    date: '2026-07-31',
  },
  {
    id: 2,
    image: 'https://readdy.ai/api/search-image?query=Music%20competition%20stage%20with%20colorful%20lighting%20and%20young%20performers%2C%20talent%20show%20atmosphere%2C%20dramatic%20spotlights%2C%20concert%20production%20quality%2C%20energetic%20vibe&width=600&height=400&seq=cards-02&orientation=landscape',
    tag: '音乐选秀',
    title: '创造营2026：全球练习生巅峰对决',
    description: '来自30国的顶尖练习生汇聚一堂，全新国际导师阵容，谁将成为下一个全球偶像？每周五晚更新。',
    date: '2026-07-30',
  },
  {
    id: 3,
    image: 'https://readdy.ai/api/search-image?query=Cozy%20countryside%20courtyard%20house%20with%20wooden%20furniture%2C%20warm%20evening%20light%2C%20Chinese%20rural%20lifestyle%2C%20peaceful%20atmosphere%2C%20homey%20and%20nostalgic%20setting&width=600&height=400&seq=cards-03&orientation=landscape',
    tag: '美食慢综',
    title: '向往的生活 第九季温暖收官',
    description: '本季累计播放量突破40亿，刷新国产慢综艺多项纪录。重温蘑菇屋那些治愈人心的美好时光。',
    date: '2026-07-28',
  },
  {
    id: 4,
    image: 'https://readdy.ai/api/search-image?query=Dimly%20lit%20detective%20room%20with%20clue%20boards%20and%20mysterious%20props%2C%20crime%20investigation%20theme%2C%20suspenseful%20atmosphere%2C%20dramatic%20lighting%2C%20cinematic%20wide%20shot&width=600&height=400&seq=cards-04&orientation=landscape',
    tag: '推理探案',
    title: '密室大逃脱 第六季定档8月8日',
    description: '六大全新沉浸式密室主题首次曝光，从古墓到未来都市，VR全景解锁全新观看维度。',
    date: '2026-07-27',
  },
  {
    id: 5,
    image: 'https://readdy.ai/api/search-image?query=Street%20dance%20battle%20on%20a%20lit%20stage%20with%20energetic%20dancers%2C%20urban%20culture%20vibe%2C%20dynamic%20motion%20capture%2C%20powerful%20performance%2C%20hiphop%20aesthetic&width=600&height=400&seq=cards-05&orientation=landscape',
    tag: '舞蹈竞技',
    title: '这就是街舞 第八季全球联赛制',
    description: '首次引入全球街舞联赛模式，美韩法顶级舞团加盟。全新战队淘汰制，这个夏天燃起来。',
    date: '2026-07-26',
  },
  {
    id: 6,
    image: 'https://readdy.ai/api/search-image?query=Comedy%20club%20stage%20with%20a%20standup%20comedian%20performing%20under%20warm%20spotlight%2C%20intimate%20venue%20atmosphere%2C%20audience%20silhouettes%2C%20professional%20comedy%20show%20setting&width=600&height=400&seq=cards-06&orientation=landscape',
    tag: '脱口喜剧',
    title: '脱口秀大会 第七季开放麦巡演',
    description: '全国20城线下开放麦巡演全面启动，线上同步直播解锁独家幕后花絮。笑声不停，精彩不断。',
    date: '2026-07-25',
  },
  {
    id: 7,
    image: 'https://readdy.ai/api/search-image?query=Bright%20Chinese%20restaurant%20with%20elegant%20interior%2C%20Barcelona%20cityscape%20visible%20through%20large%20windows%2C%20chefs%20preparing%20dishes%2C%20warm%20natural%20light%2C%20Mediterranean%20charm%20blended%20with%20Asian%20aesthetics&width=600&height=400&seq=cards-07&orientation=landscape',
    tag: '海外特辑',
    title: '中餐厅 第十季：巴塞罗那之旅',
    description: '首次踏足欧洲，在巴塞罗那开设期间限定中餐厅。用美食讲述中国故事，温暖每一颗海外游子心。',
    date: '2026-07-24',
  },
];

export const topicsData = [
  { id: 1, name: '极限挑战第十季', count: '128万讨论', color: 'primary' },
  { id: 2, name: '密室大逃脱VR', count: '96万讨论', color: 'accent' },
  { id: 3, name: '创造营2026', count: '215万讨论', color: 'secondary' },
  { id: 4, name: '向往的生活收官', count: '87万讨论', color: 'primary' },
  { id: 5, name: '这就是街舞全球赛', count: '73万讨论', color: 'accent' },
  { id: 6, name: '中餐厅巴塞罗那', count: '65万讨论', color: 'secondary' },
  { id: 7, name: '脱口秀大会巡演', count: '54万讨论', color: 'primary' },
  { id: 8, name: '暑期综艺嘉年华', count: '102万讨论', color: 'accent' },
  { id: 9, name: '综艺不缓冲', count: '41万讨论', color: 'secondary' },
  { id: 10, name: '高清综艺秒播', count: '38万讨论', color: 'primary' },
  { id: 11, name: '快看影视三周年', count: '29万讨论', color: 'accent' },
];

export const mediaData = [
  {
    id: 1,
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20thumbnail%20with%20hosts%20laughing%20together%20outdoors%2C%20bright%20and%20colorful%2C%20text%20overlay%20space%2C%20YouTube%20style%20video%20thumbnail%20design%2C%20entertaining%20vibe&width=640&height=360&seq=media-01&orientation=landscape',
    title: '极限挑战S10：先导片',
    duration: '48:32',
    views: '1280万',
    date: '3天前',
  },
  {
    id: 2,
    thumbnail: 'https://readdy.ai/api/search-image?query=Stage%20performance%20with%20singers%20and%20dancers%2C%20colorful%20concert%20lighting%2C%20talent%20show%20style%20video%20thumbnail%2C%20dramatic%20moment%2C%20high%20production%20value&width=640&height=360&seq=media-02&orientation=landscape',
    title: '创造营2026：初舞台合集',
    duration: '1:25:18',
    views: '2150万',
    date: '5天前',
  },
  {
    id: 3,
    thumbnail: 'https://readdy.ai/api/search-image?query=Mysterious%20room%20with%20dramatic%20lighting%2C%20puzzle%20solving%20scene%2C%20escape%20room%20style%20thumbnail%2C%20suspenseful%20atmosphere%2C%20cinematic%20look&width=640&height=360&seq=media-03&orientation=landscape',
    title: '密室大逃脱S6：预告分析',
    duration: '15:42',
    views: '856万',
    date: '4天前',
  },
  {
    id: 4,
    thumbnail: 'https://readdy.ai/api/search-image?query=Comedian%20on%20stage%20with%20microphone%2C%20spotlight%2C%20standup%20comedy%20performance%2C%20audience%20reaction%2C%20warm%20atmosphere%2C%20thumbnail%20style&width=640&height=360&seq=media-04&orientation=landscape',
    title: '脱口秀大会S7：首场开放麦',
    duration: '32:15',
    views: '689万',
    date: '6天前',
  },
];

export const commentsData = [
  {
    id: 1,
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20young%20Chinese%20woman%2C%20friendly%20smile%2C%20warm%20portrait%20photography%2C%20clean%20white%20background&width=80&height=80&seq=comment-avatar-01&orientation=squarish',
    name: '综艺迷小鹿',
    time: '2小时前',
    content: '快看影视真的是我用过最流畅的综艺平台！极限挑战第十季第一时间更新，画质超清还不卡顿，已经推荐给身边所有追综的朋友了。',
    likes: 328,
  },
  {
    id: 2,
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20young%20Chinese%20man%2C%20confident%20expression%2C%20clean%20portrait%20photography%2C%20white%20background&width=80&height=80&seq=comment-avatar-02&orientation=squarish',
    name: '追剧不熬夜',
    time: '5小时前',
    content: '冲了三年会员的老用户来说两句，片源更新速度真的快，好多综艺刚播完这边就能看了。离线缓存功能也很实用，通勤路上看综艺太方便了。',
    likes: 256,
  },
  {
    id: 3,
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20young%20Chinese%20woman%20with%20glasses%2C%20gentle%20smile%2C%20portrait%20photography%2C%20clean%20white%20background&width=80&height=80&seq=comment-avatar-03&orientation=squarish',
    name: '爱吃瓜的奶茶',
    time: '8小时前',
    content: '密室大逃脱第六季的预告看得我太期待了！VR全景模式这个创意绝了，感觉能沉浸式体验密室逃脱的紧张刺激。希望上线后不要让我失望！',
    likes: 189,
  },
  {
    id: 4,
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20middle%20aged%20Chinese%20man%2C%20warm%20smile%2C%20portrait%20photography%2C%20clean%20white%20background&width=80&height=80&seq=comment-avatar-04&orientation=squarish',
    name: '老综迷阿强',
    time: '12小时前',
    content: '从快看影视刚上线就在用了，见证了平台一步步成长。现在片库越来越全，经典老综也能随时重温。希望继续加油，做最好的综艺平台！',
    likes: 142,
  },
];

export const faqData = [
  {
    id: 1,
    question: '快看影视上的综艺节目需要付费吗？',
    answer: '快看影视提供大量免费综艺节目，用户无需付费即可观看海量内容。同时我们提供VIP会员服务，会员可享受1080P蓝光画质、离线缓存、无广告播放等专属权益。新用户注册即送7天免费VIP体验。',
  },
  {
    id: 2,
    question: '综艺节目更新速度快吗？播出后多久能看？',
    answer: '快看影视拥有高效的片源更新体系，热门综艺节目通常在电视台播出后2小时内即可上线。部分独家合作内容支持同步直播，让您第一时间看到最新精彩内容。',
  },
  {
    id: 3,
    question: '为什么别人看综艺会卡顿，快看影视却很流畅？',
    answer: '快看影视采用全球CDN加速技术和智能预加载算法，在全国范围内部署了超过500个加速节点。即使在弱网环境或高峰时段，也能通过自适应码率技术自动匹配最佳画质，确保不缓冲、流畅播放的观看体验。',
  },
  {
    id: 4,
    question: '支持哪些设备观看综艺节目？',
    answer: '快看影视支持全平台观看，包括PC网页端、iOS/Android手机APP、iPad平板以及智能电视投屏。一个账号可在5台设备上同时登录，让您随时随地畅享综艺精彩。',
  },
  {
    id: 5,
    question: '片库里有以前的经典综艺吗？',
    answer: '有的。快看影视收录了超过3000档综艺节目，涵盖近十年的经典内容。无论是《极限挑战》第一季、《跑男》早期系列，还是《歌手》《中国好声音》历季全集，都可以在平台找到并随时重温。',
  },
  {
    id: 6,
    question: '如何成为快看影视的内容创作者或合作伙伴？',
    answer: '我们欢迎优质内容创作者和品牌方合作。您可以通过页面底部的"联系我们"板块提交合作意向，或直接发送邮件至contact@kuaikanys.com，我们的商务团队将在3个工作日内与您取得联系。',
  },
];